const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/fixme.login.actionTypes.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const ACTION_TYPE_RESET_LOGIN_STATE = 'PATAPP_LOGIN_STATE';
export const ACTION_TYPE_RESET_SESSION_STORAGE = 'PATAPP_RESET_SESSION_STORAGE';
export const ACTION_TYPE_SET_LOGIN_DATA_AT_AUTO_LOGIN = 'PATAPP_SET_LOGIN_DATA_AT_AUTO_LOGIN';
export const REQUEST_ACTION_TYPES_GET_SMS_CODE_TOKEN = kisapiActionTypes('PATAPP_GET_TOKEN_FROM_SMSCODE');
export const REQUEST_ACTION_TYPES_SEND_SMS_FROM_INVITATION = kisapiActionTypes('PATAPP_SEND_SMS_FROM_INVITATION');

export const GET_REGISTER_WORK_ITEM = kisapiActionTypes('PATAPP_GET_REGISTER_WORKITEM');
